/* unplugin-vue-components disabled */import { render } from "./ExamQuizPlayer.vue?vue&type=template&id=4e32a818&scoped=true&ts=true"
import script from "./ExamQuizPlayer.vue?vue&type=script&lang=ts"
export * from "./ExamQuizPlayer.vue?vue&type=script&lang=ts"

import "./ExamQuizPlayer.vue?vue&type=style&index=0&id=4e32a818&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e32a818"]])

export default __exports__